import axios from 'axios'
import store from '../store/index'
import VueCookie from 'vue-cookies'
const timeOut = null

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (localStorage.getItem('language')) {
    config.headers.common.Language = localStorage.getItem('language')
  } else {
    localStorage.setItem('language', 'hu')
    config.headers.common.Language = 'hu'
  }

  if (VueCookie.get('token')) {
    config.headers.common.Authorization = 'Bearer ' + VueCookie.get('token')
  }

  return config
}, function (error) {
  // Do something with request error
  clearTimeout(timeOut)
  return Promise.reject(error)
})

axios.interceptors.response.use(
  function (response) {
    if (response.config.method !== 'get') {
      if (!response.headers.hide_alert && response.headers.hide_alert !== '1') {
      }
    }
    if (VueCookie.get('token')) {
      VueCookie.set('token', VueCookie.get('token'), 60 * 60)
    }

    store.commit('defaultStore/setErrors', [])
    clearTimeout(timeOut)

    return response
  },
  function (error) {
    if (error.response.data && error.response.data.errors) {
      store.commit('defaultStore/setErrors', error.response.data.errors)
    }

    if (error.response.status && error.response.status === 401) {
    } else if (error.response.status && error.response.status === 422) {
    } else {
      if (!error.response.config.url.startsWith('/storage/')) {
      }
    }

    clearTimeout(timeOut)
    return Promise.reject(error)
  }
)



// WEBPACK FOOTER //
// ./src/axiox/axios-interceptor.js